import React from 'react';
import { MenuItem, ListItemIcon, ListItemText } from '@mui/material';

export const AdminButtons = ({
    accountingSettlement,
    activeClients,
    handleOpenConfirmDialog,
    openApproveForPaymentDialog,
    canAddBlock,
    handleOpenAddBlockDialog,
    canAddAdditionalFee,
    handleOpenAdditionalFeeDialog,
    handleClose
}) => {
    return (
        <>
            {!(accountingSettlement?.statementFinished || activeClients == 0) && (
                <MenuItem onClick={() => { handleClose(); handleOpenConfirmDialog("Zakończ i wyślij zestawienie", "Czy potwierdzasz, że chcesz zakończyć i wysłać zestawienie?", "saveAndSend", false); }}>
                    <ListItemIcon><i className="fas fa-paper-plane" style={{ color: '#10b981', fontSize: '1.2rem' }}></i></ListItemIcon>
                    <ListItemText primary="Zakończ i wyślij" />
                </MenuItem>
            )}
            {accountingSettlement?.statementFinished && (
                <MenuItem onClick={() => { handleClose(); handleOpenConfirmDialog("Odblokuj do edycji", "Czy potwierdzasz, że chcesz odblokować zestawienie do edycji?", "unlock", true); }}>
                    <ListItemIcon><i className="fas fa-lock-open" style={{ color: '#f59e0b', fontSize: '1.2rem' }}></i></ListItemIcon>
                    <ListItemText primary="Odblokuj do edycji" />
                </MenuItem>
            )}
            {!(accountingSettlement?.statementApproved || !accountingSettlement?.statementFinished) && (
                <MenuItem onClick={() => { handleClose(); openApproveForPaymentDialog(); }}>
                    <ListItemIcon><i className="fas fa-check-double" style={{ color: '#3b82f6', fontSize: '1.2rem' }}></i></ListItemIcon>
                    <ListItemText primary="Zatwierdź do wypłaty" />
                </MenuItem>
            )}
            {accountingSettlement?.statementFinished && accountingSettlement?.isDeclarationSent && (
                <MenuItem onClick={() => { handleClose(); handleOpenConfirmDialog("Odblokuj faktury", `Czy potwierdzasz, że chcesz odblokować proces?`, "unlockDeclaration", true); }}>
                    <ListItemIcon><i className="fas fa-file-invoice" style={{ color: '#f59e0b', fontSize: '1.2rem' }}></i></ListItemIcon>
                    <ListItemText primary="Odblokuj faktury" />
                </MenuItem>
            )}
            {canAddBlock && (
                <MenuItem onClick={() => { handleClose(); handleOpenAddBlockDialog(); }}>
                    <ListItemIcon><i className="fas fa-ban" style={{ color: '#ef4444', fontSize: '1.2rem' }}></i></ListItemIcon>
                    <ListItemText primary="Dodaj blokadę" />
                </MenuItem>
            )}
            {canAddAdditionalFee && (
                <MenuItem onClick={() => { handleClose(); handleOpenAdditionalFeeDialog(); }}>
                    <ListItemIcon><i className="fas fa-money-bill-wave" style={{ color: '#8b5cf6', fontSize: '1.2rem' }}></i></ListItemIcon>
                    <ListItemText primary="Dodatkowa opłata" />
                </MenuItem>
            )}
        </>
    );
};